// @ts-nocheck
/* eslint-enable */
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import cx from 'classnames';
import styled from 'styled-components';
import { useYieldCallback } from '@zillow/yield-callback';

import './style.scss';
import controller from './controller';
import numberUtils from 'app/shared/utils/numberUtils';
import Text from 'app/shared/core/Text';

const StyledBoldDiv = styled.div`
  font-weight: 700;
`;

type ContactPhoneProps = {
  className?: string;
  isPopUp?: boolean;
  onClick?: () => void;
  // NEW: Props-based listing data (preferred over Redux)
  listing?: {
    address?: any;
    aliasEncoded?: string;
    isApartmentBldg?: boolean;
    isPaidMultifamily?: boolean;
    isPaidAndNotDemoted?: boolean;
    listedBy?: {
      contactPhone?: string;
      [key: string]: any;
    };
    maloneLotIdEncoded?: string;
    trusted?: boolean;
    [key: string]: any;
  };
};

const ContactPhone = ({ className, isPopUp, onClick = () => {}, listing }: ContactPhoneProps) => {
  // Redux (fallback for backward compatibility)
  const dispatch = useDispatch();
  const deviceType = useSelector((state) => state.app.device.deviceType);
  const currentListingFromRedux = useSelector((state) => state.currentListingDetails.currentListing);

  // React state and hooks - MUST be called before any early returns
  const [isContactNumberVisible, setIsContactNumberVisible] = useState(false);

  const handlePhoneClick = useYieldCallback(() => {
    onClick();
  });

  // ARCHITECTURAL FIX: Use props-based listing data when available, fallback to Redux
  // This fixes the SRP modal issue where currentListing is null in Redux
  const effectiveListing = listing || currentListingFromRedux;

  // Early return if no listing data available from either source
  if (!effectiveListing) {
    console.warn('ContactPhone: No listing data available from props or Redux');
    return null;
  }

  const {
    address,
    aliasEncoded,
    isApartmentBldg,
    isPaidMultifamily,
    isPaidAndNotDemoted,
    listedBy,
    maloneLotIdEncoded,
    trusted,
  } = effectiveListing;

  // Safety check for listedBy
  if (!listedBy) {
    console.warn('ContactPhone: No listedBy data available');
    return null;
  }

  const { contactPhone } = listedBy;

  // If no contact phone, don't render anything
  if (!contactPhone) {
    return null;
  }

  const handleShowContactClick = () => {
    setIsContactNumberVisible(true);
  };

  return (
    <div className={cx('ContactPhone', className)}>
      {controller.showAfterHoursPhone() ? (
        <div onClick={handleShowContactClick}>
          <StyledBoldDiv>
            <Text size="sm">After business hours - response may be delayed</Text>
          </StyledBoldDiv>
          {isContactNumberVisible ? (
            <Text size="sm" className="ContactPhone-listedby-phone-link">
              {numberUtils.getDisplayPhoneNumber(contactPhone)}
            </Text>
          ) : (
            <Text size="sm" className="ContactPhone-show-phone">
              Click for phone
            </Text>
          )}
        </div>
      ) : (
        <div className="ContactPhone-listedby-phone">
          <a className="ContactPhone-listedby-phone-link" href={'tel://' + contactPhone} onClick={handlePhoneClick}>
            <Text size="sm">{numberUtils.getDisplayPhoneNumber(contactPhone)}</Text>
          </a>
        </div>
      )}
    </div>
  );
};

export default ContactPhone;
